import { FC, PropsWithChildren, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import classes from './Main.module.scss';

const Main: FC<PropsWithChildren<{ showHeader: boolean }>> = ({ children, showHeader }) => {
    const location = useLocation();
    const mainRef = useRef<HTMLElement>(null);

    useEffect(() => {
        if (mainRef.current) {
            mainRef.current.scrollTop = 0;
        }
    }, [location]);

    return (
        <main ref={mainRef} className={`${classes.main} ${showHeader ? classes.showHeader : ''}`}>
            {children}
        </main>
    );
}

export default Main;
